















import { Component, Prop, Vue } from 'vue-property-decorator';
import MoreButton from '@/components/parts/catalog/list/item/components/More.vue';
import { AppHeading, ListCardBadge, AppPicture } from '@/uikit';

@Component({
  components: {
    AppHeading,
    MoreButton,
    AppPicture,
    ListCardBadge,
  },
})
export default class ProfessionListCard extends Vue {
  @Prop({ type: String, default: '' })
  readonly id!: string;

  @Prop({ type: String, default: '' })
  readonly title!: string;

  @Prop({ type: String, default: '' })
  readonly image!: string;

  @Prop({ type: Number, default: null })
  readonly competencesCount!: number | null;

  @Prop({ type: Number, default: null })
  readonly eventsCount!: number | null;

  get badges() {
    const { competencesCount, eventsCount } = this;
    const badges = [];
    if (competencesCount)
      badges.push({
        title: `${competencesCount} комп.`,
        mod: 'red',
      });
    if (eventsCount)
      badges.push({ title: `${eventsCount} прог.`, mod: 'blue' });
    return badges;
  }

  get linkParam() {
    const { id } = this;
    return { name: 'profession', params: { id } };
  }

  get coverImageStyle() {
    const { image } = this;
    if (!image) return false;
    return { 'background-image': `url(${this.image})` };
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/professions/card/ProfessionListCard.vue